import classNames from "classnames";
import lodash from "lodash";
import React from "react";
import { Loader, MediaItemErrorMsg } from "./../../ui-components";
import { getContainerClasses } from "../../_shared/figure/get-container-classes";
import { VIDEO_ROOT } from "../data-hooks";
import styles from "../statics/styles/default-video-styles-scss";
import { Video } from "../viewer/video";
class VideoComponent extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.handleReady = (player) => {
      if (!this.state.isLoaded) {
        this.setState({ isLoaded: true });
      }
      this.handleDuration(player);
    };
    this.handleDuration = (player) => {
      setTimeout(() => {
        const duration = player.current?.getDuration();
        if (duration) {
          this.saveDurationToData(duration);
        } else {
          this.setState({ shouldRenderDurationFix: true });
        }
      }, 3e3);
    };
    this.renderLoader = () => {
      const isCustomVideo = "video" in this.props.componentData && !!this.props.componentData.video?.src?.id;
      return /* @__PURE__ */ React.createElement("div", { className: styles.videoOverlay }, /* @__PURE__ */ React.createElement(
        Loader,
        {
          type: "medium",
          isVerySlowFakeLoader: isCustomVideo,
          percent: this.props.loadingPercentage,
          disableProgress: !this.props.isLoading && !this.state.isLoaded
        }
      ));
    };
    this.saveDurationToData = (duration) => {
      const { componentData, updateAttributes } = this.props;
      const video = "video" in componentData ? componentData.video : {};
      updateAttributes({ ...componentData, video: { ...video || {}, duration } });
    };
    this.renderPlayer = () => {
      const { componentData, config, nodeId } = this.props;
      return /* @__PURE__ */ React.createElement(
        Video,
        {
          componentData,
          config,
          onReady: this.handleReady,
          isLoaded: this.state.isLoaded,
          key: this.state.iosFixKey,
          nodeId,
          isLight: false,
          disabled: true
        }
      );
    };
    this.renderPlayerDurationFix = () => {
      const { componentData, config, nodeId } = this.props;
      const play = (player) => {
        const internalPlayer = player.current?.getInternalPlayer();
        if (internalPlayer && "play" in internalPlayer && lodash.isFunction(internalPlayer.play)) {
          internalPlayer.play();
          return true;
        }
        return false;
      };
      const onReady = (player) => {
        const hasPlayed = play(player);
        if (hasPlayed) {
          return;
        }
        this.durationFixTimeoutId = setTimeout(() => {
          play(player);
        }, 1e4);
      };
      return /* @__PURE__ */ React.createElement("div", { className: styles.hide_duration }, /* @__PURE__ */ React.createElement(
        Video,
        {
          componentData,
          config,
          onReady,
          isLight: false,
          onDuration: (duration) => {
            this.setState({ shouldRenderDurationFix: false });
            this.saveDurationToData(duration);
            clearTimeout(this.durationFixTimeoutId);
          },
          nodeId,
          muted: true
        }
      ));
    };
    this.state = {
      isLoaded: false,
      iosFixKey: 1
    };
  }
  componentDidMount() {
    this.handlePlayerFocus();
  }
  componentDidUpdate() {
    this.handlePlayerFocus();
  }
  componentWillUnmount() {
    clearTimeout(this.durationFixTimeoutId);
  }
  handlePlayerFocus() {
    const element = this.containerRef.current?.querySelector("iframe, video");
    if (element) {
      element.tabIndex = -1;
    }
  }
  render() {
    const {
      t,
      componentData: { error },
      isLoading
    } = this.props;
    const { isLoaded, shouldRenderDurationFix } = this.state;
    const loading = isLoading || !isLoaded;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.containerRef,
        "data-hook": VIDEO_ROOT,
        className: classNames(
          styles.video_container,
          getContainerClasses(this.props.editor, this.props.nodeId, false)
        ),
        draggable: true,
        "data-drag-handle": true
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.video_overlay }),
      this.renderPlayer(),
      shouldRenderDurationFix ? this.renderPlayerDurationFix() : null,
      loading && !error && this.renderLoader(),
      error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error, t })
    );
  }
}
export {
  VideoComponent
};
//# sourceMappingURL=video-component.js.map
